import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "show",
    onAfterLeave: _ctx.afterLeave
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['box', 'item', _ctx.notification.type])
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.notification.message), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("span", {
            class: "material-icons close p-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "close")
        ], 2)
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }, 8, ["onAfterLeave"]))
}